import { Feature } from 'src/store/app/types';

const isFeatureEnabled = (feature: Feature) => (
  window.integrationLayer && window.integrationLayer.features && window.integrationLayer.features.indexOf(feature) !== -1
);

export default isFeatureEnabled;
